import { render, staticRenderFns } from "./zhuanyehouzhui.vue?vue&type=template&id=0345facb&scoped=true&"
import script from "./zhuanyehouzhui.vue?vue&type=script&lang=js&"
export * from "./zhuanyehouzhui.vue?vue&type=script&lang=js&"
import style0 from "./zhuanyehouzhui.vue?vue&type=style&index=0&id=0345facb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345facb",
  null
  
)

export default component.exports